import { Plus, Minus, X } from "@phosphor-icons/react";
import { fmtMoney } from "@/lib/format";

// Shared cart lines + totals (No AI kiosk cart and the AI Cashier's Browse Menu cart).
// lines: [{ key, name, modifiers: [{ name, qty }], qty, total }]
export function CartLines({ lines, onInc, onDec, onRemove }) {
  return (
    <>
      {lines.length === 0 && <div className="text-center text-sm text-[var(--ink-500)] py-6">Cart is empty.</div>}
      <div className="space-y-2 mb-4">
        {lines.map((i, n) => (
          <div key={i.key} className="flex items-start justify-between gap-2 border-b border-[rgba(28,25,23,0.06)] pb-2">
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{i.name}</div>
              {i.modifiers.length > 0 && <div className="text-[11px] text-[var(--ink-500)]" data-testid="co-cart-mod-line">{i.modifiers.map((m) => {
                const q = Number(m.qty || 1);
                return q > 1 ? `${m.name} x${q}` : m.name;
              }).join(" · ")}</div>}
              <div className="flex items-center gap-2 mt-1">
                <button onClick={() => onDec(i.key)} data-testid={`co-cart-dec-${n}`} className="w-6 h-6 rounded-md border border-[rgba(28,25,23,0.12)]"><Minus size={10} className="m-auto" /></button>
                <span className="text-sm tabular w-4 text-center">{i.qty}</span>
                <button onClick={() => onInc(i.key)} data-testid={`co-cart-inc-${n}`} className="w-6 h-6 rounded-md border border-[rgba(28,25,23,0.12)]"><Plus size={10} className="m-auto" /></button>
              </div>
            </div>
            <div className="text-sm tabular font-medium">{fmtMoney(i.total)}</div>
            <button onClick={() => onRemove(i.key)} data-testid={`co-cart-remove-${n}`} className="text-[var(--ink-500)]"><X size={14} /></button>
          </div>
        ))}
      </div>
    </>
  );
}

export function CartTotals({ subtotal, publicHoliday = null, publicHolidayAmount = 0, deliveryFee = 0, total, extra = null }) {
  return (
    <div className="space-y-1 text-sm border-t border-[rgba(28,25,23,0.06)] pt-3">
      <div className="flex justify-between"><span className="text-[var(--ink-500)]">Subtotal</span><span className="tabular">{fmtMoney(subtotal)}</span></div>
      {publicHoliday?.applies && publicHolidayAmount > 0 && (
        <div className="flex justify-between" data-testid="co-ph-surcharge-line" data-ph-amount={publicHolidayAmount}>
          <span className="text-[var(--ink-500)]">
            Public holiday surcharge ({publicHoliday.rate}%)
            {publicHoliday.label ? ` – ${publicHoliday.label}` : ""}
          </span>
          <span className="tabular">{fmtMoney(publicHolidayAmount)}</span>
        </div>
      )}
      {deliveryFee > 0 && <div className="flex justify-between"><span className="text-[var(--ink-500)]">Delivery</span><span className="tabular">{fmtMoney(deliveryFee)}</span></div>}
      {extra}
      <div className="flex justify-between font-heading text-xl font-semibold pt-1"><span>Total</span><span className="tabular" data-testid="co-cart-total">{fmtMoney(total)}</span></div>
      {publicHoliday?.applies && publicHolidayAmount > 0 && (
        <div className="text-[11px] text-[var(--ink-500)] pt-1" data-testid="co-ph-surcharge-note">
          {publicHoliday.rate}% public holiday surcharge applies today.
        </div>
      )}
    </div>
  );
}
